import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import styled from 'styled-components'
import { _ } from 'utils'
import Icon from 'components/Icon'
import { BackButton } from 'components/ReusableStyledComponents'
import { showNotification } from 'features/notifications/notificationsSlice'
import {
    closeImageLibrary,
    setCurrentSelectedImage,
    showImageLibrarySelector
} from './imageLibrarySlice'
import ImageLibrary from './ImageLibrary'

const S = {
    Wrapper: styled.div<{ show?: boolean }>`
        display: ${({ show }) => (show ? 'block' : 'none')};
        position: absolute;
        top: 60px;
        left: 0;
        width: 100vw;
        height: calc(100vh - 60px);
        padding: 30px 0 20px 0;
        background-color: #F9F9F9;
        z-index: 99;
    `,
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1440px;
        width: 80%;
        min-height: 100%;
        margin: auto;
    `,
    ImagePickerContainer: styled.div`
        flex-grow: 1;
        width: 100%;
        height: calc(100vh - 147px);
        padding: 16px;
        background: white;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        overflow: auto;
    `,
}
const ImageLibraryPage = () => {
    const location = useLocation()
    const showGallery = useSelector(showImageLibrarySelector)
    const dispatch = useDispatch()

    useEffect(() => {
        // Close the image library when route path is changed
        dispatch(closeImageLibrary())
    }, [dispatch, location.pathname])

    const handleSelectImage = (url) => {
        dispatch(showNotification({
            type: 'success',
            body: _('image.select_success'),
            displayDuration: 1500
        }))
        dispatch(setCurrentSelectedImage(url))
        dispatch(closeImageLibrary())
    }

    return (
        <S.Wrapper show={showGallery}>
            <S.Container>
                <BackButton onClick={() => dispatch(closeImageLibrary())}>
                    <Icon icon="chevronDown" />
                    {_('button.back')}
                </BackButton>
                <S.ImagePickerContainer>
                    <ImageLibrary onSelectImage={handleSelectImage} />
                </S.ImagePickerContainer>
            </S.Container>
        </S.Wrapper>
    )
}

export default ImageLibraryPage
